import Vue from "vue";

import {
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Icon,
  Pagination,
  Input,
  Form,
  FormItem,
  Dialog,
  Dropdown,
  Popover,
  Radio,
  RadioGroup,
  RadioButton,
  InputNumber,
  Tabs,
  TabPane,
  Message,
  MessageBox,
  Collapse,
  CollapseItem,
  Table,
  TableColumn,
  DatePicker,
  Row,
  Col,
  Tooltip,
  Image,
  Tag,
  Cascader,
  Descriptions,
  DescriptionsItem,
  Select,
  Option,
  Loading
} from "element-ui";

Vue.use(Button);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Icon);
Vue.use(Pagination);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(InputNumber);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tooltip);
Vue.use(Image);
Vue.use(Tag);
Vue.use(Cascader);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Loading);
// Vue.use(Otion)

Vue.prototype.$ELEMENT = {
  size: "small",
  zIndex: 3000
};

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$loading = Loading.service;



// WEBPACK FOOTER //
// ./src/utils/register-element-ui.js